import styled from "styled-components";
import {Scrollbars} from "react-custom-scrollbars";

export const StyledScrollbar = styled(Scrollbars)`
  flex: 2;
  height: 100%;
  width: 100%;
`;